// Water reveal: Perlin noise dissolve that reveals the logo
// Same dissolve style as gate-transition but in reverse (opaque -> transparent)
(function() {
  var canvas = document.getElementById('water-overlay');
  if (!canvas) return;

  var bgSrc = canvas.dataset.bgSrc;
  var gl = canvas.getContext('webgl', { premultipliedAlpha: false, alpha: true });
  if (!gl) return;

  var vsrc = 'attribute vec2 pos;varying vec2 uv;void main(){uv=pos*0.5+0.5;gl_Position=vec4(pos,0.0,1.0);}';

  var fsrc = [
    'precision highp float;',
    'varying vec2 uv;',
    'uniform sampler2D tex;',
    'uniform float time;',
    'uniform float progress;',
    'vec3 mod289(vec3 x){return x-floor(x/289.0)*289.0;}',
    'vec2 mod289v2(vec2 x){return x-floor(x/289.0)*289.0;}',
    'vec3 permute(vec3 x){return mod289(((x*34.0)+1.0)*x);}',
    'float snoise(vec2 v){',
    '  const vec4 C=vec4(0.211324865405187,0.366025403784439,-0.577350269189626,0.024390243902439);',
    '  vec2 i=floor(v+dot(v,C.yy));vec2 x0=v-i+dot(i,C.xx);',
    '  vec2 i1=(x0.x>x0.y)?vec2(1.0,0.0):vec2(0.0,1.0);',
    '  vec4 x12=x0.xyxy+C.xxzz;x12.xy-=i1;',
    '  i=mod289v2(i);',
    '  vec3 p=permute(permute(i.y+vec3(0.0,i1.y,1.0))+i.x+vec3(0.0,i1.x,1.0));',
    '  vec3 m=max(0.5-vec3(dot(x0,x0),dot(x12.xy,x12.xy),dot(x12.zw,x12.zw)),0.0);',
    '  m=m*m;m=m*m;',
    '  vec3 x=2.0*fract(p*C.www)-1.0;vec3 h=abs(x)-0.5;',
    '  vec3 ox=floor(x+0.5);vec3 a0=x-ox;',
    '  m*=1.79284291400159-0.85373472095314*(a0*a0+h*h);',
    '  vec3 g;g.x=a0.x*x0.x+h.x*x0.y;g.yz=a0.yz*x12.xz+h.yz*x12.yw;',
    '  return 130.0*dot(m,g);',
    '}',
    'void main(){',
    '  float t=time*0.3;',
    '  float n1=snoise(uv*3.0+vec2(t*0.4,t*0.3))*0.5+0.5;',
    '  float n2=snoise(uv*6.0-vec2(t*0.5,t*0.4))*0.5+0.5;',
    '  float n3=snoise(uv*12.0+vec2(t*0.7,-t*0.6))*0.5+0.5;',
    '  float noise=n1*0.5+n2*0.3+n3*0.2;',
    '  float alpha=smoothstep(progress-0.1,progress+0.05,noise);',
    '  vec4 color=texture2D(tex,uv);',
    '  gl_FragColor=vec4(color.rgb,alpha);',
    '}',
  ].join('\n');

  function cs(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    return s;
  }

  var prog = gl.createProgram();
  gl.attachShader(prog, cs(gl.VERTEX_SHADER, vsrc));
  gl.attachShader(prog, cs(gl.FRAGMENT_SHADER, fsrc));
  gl.linkProgram(prog);
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1,1,-1,-1,1,1,1]), gl.STATIC_DRAW);
  var posLoc = gl.getAttribLocation(prog, 'pos');
  gl.enableVertexAttribArray(posLoc);
  gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);

  var timeLoc = gl.getUniformLocation(prog, 'time');
  var progressLoc = gl.getUniformLocation(prog, 'progress');

  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

  var texture = gl.createTexture();
  var img = new Image();
  img.crossOrigin = 'anonymous';

  img.onload = function() {
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    var maskSrc = canvas.dataset.maskSrc;

    function updateSize() {
      canvas.width = window.innerWidth * devicePixelRatio;
      canvas.height = window.innerHeight * devicePixelRatio;
      gl.viewport(0, 0, canvas.width, canvas.height);

      // Position mask to match logo exactly
      if (maskSrc) {
        var logo = document.querySelector('.gate-logo');
        if (logo) {
          var r = logo.getBoundingClientRect();
          var maskPos = r.left + 'px ' + r.top + 'px';
          var maskSize = r.width + 'px ' + r.height + 'px';
          canvas.style.webkitMaskImage = "url('" + maskSrc + "')";
          canvas.style.maskImage = "url('" + maskSrc + "')";
          canvas.style.webkitMaskSize = maskSize;
          canvas.style.maskSize = maskSize;
          canvas.style.webkitMaskPosition = maskPos;
          canvas.style.maskPosition = maskPos;
          canvas.style.webkitMaskRepeat = 'no-repeat';
          canvas.style.maskRepeat = 'no-repeat';
        }
      }
    }

    var loadTime = performance.now();
    var delay = 0;
    var startTime = loadTime + delay;
    var duration = 1600;

    function loop(t) {
      updateSize();

      var elapsed = t - startTime;
      var progress = Math.min(Math.max(elapsed / duration, 0.0), 1.0);
      var eased = 1.0 - Math.pow(1.0 - progress, 2.0);

      gl.uniform1f(timeLoc, t * 0.001);
      gl.uniform1f(progressLoc, eased);

      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

      if (progress < 1.0) {
        requestAnimationFrame(loop);
      } else {
        canvas.style.transition = 'opacity 0.15s';
        canvas.style.opacity = '0';
        setTimeout(function() { canvas.style.display = 'none'; }, 150);
      }
    }

    requestAnimationFrame(loop);
  };

  img.src = bgSrc;
})();
